package com.fireavert.events.mark_as_false_alarm.client.presentation

data class ViewState(val loading: Boolean = true)

